(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-collection-list-style-7"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ctSliderResizeRefresh) return;
    window.ctSliderResizeRefresh = true;

    let resizeTimer = -1;
    let frame = -1;
    let observed = false;

    const setSliderModes = () => {
      document.querySelectorAll('.ct-slider').forEach((slider) => {
        const width = slider.getBoundingClientRect().width || window.innerWidth;
        slider.setAttribute('data-ct-slider-mode', width >= 992 ? 'desktop' : 'mobile');
      });
    };

    const refreshSlider = (phase = 'early') => {
      if (phase === 'early') frame = -1;
      setSliderModes();

      document.querySelectorAll('.ct-slider xo-carousel').forEach((carousel) => {
        const value = String(Date.now());
        const activeBullet = carousel.querySelector('xo-carousel-bullet[xo-active]:not([xo-active="false"])');
        const activeIndex = activeBullet ? Number(activeBullet.getAttribute('xo-index') || 0) : 0;
        carousel.style.removeProperty('--xo-per-view');
        carousel.style.removeProperty('--xo-gap');
        carousel.style.removeProperty('--xo-speed');

        carousel.setAttribute('xo-observed', value);
        carousel.querySelectorAll('xo-carousel-list').forEach((list) => {
          list.style.removeProperty('transform');
          list.style.removeProperty('touch-action');
          list.removeAttribute('xo-dragging');
          list.setAttribute('xo-observed', value);
        });

        window.setTimeout(() => {
          if (window.xoCarousel && carousel.xoName) {
            window.xoCarousel.goTo(carousel.xoName, activeIndex);
          }
        }, phase === 'early' ? 140 : 40);
      });

      if (phase === 'early') {
        window.setTimeout(() => refreshSlider('late'), 180);
      }
    };

    const scheduleRefresh = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        setSliderModes();
        if (frame !== -1) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(refreshSlider);
      }, 120);
    };

    const observeSliderSize = () => {
      if (observed || !window.ResizeObserver) return;
      observed = true;

      const observer = new ResizeObserver(scheduleRefresh);
      document.querySelectorAll('.ct-slider').forEach((slider) => observer.observe(slider));
      observer.observe(document.documentElement);

      document.addEventListener('shopify:section:load', () => {
        document.querySelectorAll('.ct-slider').forEach((slider) => observer.observe(slider));
      });
    };

    window.addEventListener('resize', scheduleRefresh, { passive: true });
    window.addEventListener('orientationchange', scheduleRefresh, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleRefresh, { passive: true });
    }
    if (window.matchMedia) {
      const breakpoint = window.matchMedia('(min-width: 992px)');
      if (breakpoint.addEventListener) {
        breakpoint.addEventListener('change', scheduleRefresh);
      } else if (breakpoint.addListener) {
        breakpoint.addListener(scheduleRefresh);
      }
    }
    document.addEventListener('shopify:section:load', scheduleRefresh);
    observeSliderSize();
    setSliderModes();
    window.requestAnimationFrame(setSliderModes);
  })();

  } catch(e) { console.error(e); }
})();
})();
